import React from 'react'

export default function CompanyDescription() {
  return (
    <div>CompanyDescription</div>
  )
}
